import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import { Button } from "../components/ui/button";
import { ArrowRight } from "lucide-react";

const DURATION = 8;

export default function Splash() {
  const navigate = useNavigate();
  const { lang, setLang } = useI18n();
  const [remaining, setRemaining] = useState(DURATION);

  useEffect(() => {
    const startedAt = Date.now();
    const iv = setInterval(() => {
      const elapsed = (Date.now() - startedAt) / 1000;
      const left = Math.max(0, DURATION - elapsed);
      setRemaining(left);
      if (left <= 0) {
        clearInterval(iv);
        try { sessionStorage.setItem("mfis_splash_seen", "1"); } catch (e) { /* ignore */ }
        navigate("/login", { replace: true });
      }
    }, 100);
    return () => clearInterval(iv);
  }, [navigate]);

  const goLogin = () => {
    try { sessionStorage.setItem("mfis_splash_seen", "1"); } catch (e) { /* ignore */ }
    navigate("/login", { replace: true });
  };

  const pct = ((DURATION - remaining) / DURATION) * 100;

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center relative overflow-hidden" data-testid="splash-page">
      {/* Language toggle */}
      <div className="absolute top-4 right-4 flex border">
        {["es", "en"].map((l) => (
          <button key={l} onClick={() => setLang(l)} data-testid={`splash-lang-${l}`}
            className={`px-2.5 py-1 text-[10px] font-bold uppercase ${lang === l ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`}>{l}</button>
        ))}
      </div>

      {/* Logo animated */}
      <div className="flex-1 flex items-center justify-center w-full px-8">
        <img
          src="/brand/oomining-welcome.jpg"
          alt="OOMINING - Mine Management Software"
          className="max-w-3xl w-full h-auto animate-splash-in"
          data-testid="splash-logo"
        />
      </div>

      {/* Bottom bar: progress + button */}
      <div className="w-full max-w-md px-6 pb-10 space-y-4">
        <div className="flex items-center justify-between text-[10px] font-bold uppercase tracking-widest text-slate-500">
          <span>
            {lang === "es" ? "Cargando plataforma" : "Loading platform"} · {Math.ceil(remaining)}s
          </span>
          <span>MFIS Supply-Chain</span>
        </div>
        <div className="h-1 bg-slate-200 relative overflow-hidden">
          <div className="absolute inset-y-0 left-0 bg-[#F29A2E] transition-all"
            style={{ width: `${pct}%` }} data-testid="splash-progress" />
        </div>
        <Button
          onClick={goLogin}
          data-testid="splash-go-login"
          className="w-full rounded-none font-bold uppercase tracking-widest bg-[#1F3E7C] hover:bg-[#152C5A] text-white active:scale-95 transition-transform"
        >
          {lang === "es" ? "Ir al inicio de sesión" : "Go to sign in"}
          <ArrowRight size={14} className="ml-2" />
        </Button>
        <div className="text-center text-[10px] text-slate-400 uppercase tracking-widest">
          © {new Date().getFullYear()} OOMINING · Chihuahua, México
        </div>
      </div>

      <style>{`
        @keyframes splashIn {
          0% { opacity: 0; transform: scale(0.85) translateY(20px); }
          60% { opacity: 1; transform: scale(1.02) translateY(0); }
          100% { opacity: 1; transform: scale(1) translateY(0); }
        }
        .animate-splash-in { animation: splashIn 1.6s cubic-bezier(.2,.8,.2,1) both; }
      `}</style>
    </div>
  );
}
